/**
 * Get consistent status color across the application
 * @param {string} status - Status value
 * @returns {string} - MUI color name ('success', 'error', 'warning', 'info', 'default')
 */
export const getStatusColor = (status) => {
  if (!status) return 'default';
  const statusLower = status.toString().toLowerCase();
  
  // Success states
  if (statusLower.includes('success') || statusLower.includes('active') || 
      statusLower === 'paid' || statusLower.includes('completed') ||
      statusLower.includes('approved') || statusLower === 'posted') {
    return 'success';
  }
  
  // Error states
  if (statusLower.includes('error') || statusLower.includes('failed') || 
      statusLower.includes('cancelled') || statusLower.includes('rejected') ||
      statusLower.includes('overdue') || statusLower === 'overdue' || statusLower === 'unpaid') {
    return 'error';
  }
  
  // Warning states
  if (statusLower.includes('warning') || statusLower.includes('pending') || 
      statusLower.includes('partial') || statusLower === 'draft' ||
      statusLower === 'partially paid' || statusLower === 'partially_paid' || 
      statusLower === 'reversed' || statusLower === 'due') {
    return 'warning';
  }
  
  // Info states
  if (statusLower.includes('info') || statusLower === 'sent' ||
      statusLower.includes('processing') || statusLower === 'general' ||
      statusLower === 'opening' || statusLower === 'closing' ||
      statusLower === 'adjusting' || statusLower === 'reversing' ||
      statusLower === 'correction') {
    return 'info';
  }
  
  return 'default';
};

/**
 * Check if a record is approved/locked
 * @param {object} record - Record with status/approvalStatus
 * @returns {boolean} - True if record is locked
 */
export const isRecordLocked = (record) => {
  if (!record) return false;
  
  const status = record.status?.toLowerCase();
  const approvalStatus = record.approvalStatus?.toLowerCase();
  
  return status === 'approved' || 
         status === 'posted' || 
         approvalStatus === 'approved' ||
         status === 'paid';
};

/**
 * Get lock icon visibility for a record
 * @param {object} record - Record to check
 * @returns {boolean} - True if lock icon should be shown
 */
export const shouldShowLockIcon = (record) => {
  return isRecordLocked(record);
};
